import { speakersPaletteTokensList } from '@braskai/ui-kit';

export const spaceColorOptions = speakersPaletteTokensList.map((token) => ({ label: token, value: token }));
